import * as types from './actionTypes';  
import offeringAttributionApi from '../api/offeringAttributionApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchOfferingAttribution() {

  return {
    type: types.DO_FETCH_OFFERING_ATTRIBUTION, 
    
  };
}

export function doFetchOfferingAttributionRes(data) {  
  return {
    type: types.DO_FETCH_OFFERING_ATTRIBUTION_RES, 
    data
  };
}

export function fetchOfferingAttribution() {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      offeringAttributionApi.doFetchOfferingAttribution().then(data => {
        dispatch(doFetchOfferingAttributionRes(data));
        dispatch(doFetchOfferingAttributionRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}